/**
 * Created by Tiger on 09/06/2022.
 */
import React, {useState} from "react";
import {InputProps} from "antd/lib/input/Input";
import {Image, Input, InputRef} from "antd";
import styled from "@emotion/styled";

interface InputWithLabelProps extends InputProps {
  isPasswordInput?: boolean
}


const InputWithLabel = React.forwardRef<InputRef, InputWithLabelProps>(function (props, ref) {
  const {style, placeholder, isPasswordInput, ...restProps} = props
  const [inputFocus, setInputFocus] = useState(false);

  const InputComponent = isPasswordInput ? MyPasswordInput : MyInput
  return <InputContainer>
    <MyLabel style={{opacity: inputFocus ? 1 : 0}}>{placeholder}</MyLabel>
    <InputComponent style={{height: 48}}
                    iconRender={(visible) => {
                      return <div style={{padding: 5, paddingRight: 0}}>
                        <img style={{width: 19,}}
                             src={visible ? require('../../../assets/login/mobile/passwd_eye_open@3x.png') : require('../../../assets/login/mobile/passwd_eye_closed@3x.png')}/>
                      </div>
                    }}
                    id={'input'}
                    ref={ref}
                    onFocus={(event) => {
                      setInputFocus(true)
                      props.onFocus?.(event)
                    }}
                    onBlur={(event) => {
                      setInputFocus(false)
                      props.onBlur?.(event)
                    }}
                    placeholder={inputFocus ? '' : placeholder}
                    {...restProps}
    />
  </InputContainer>
})

InputWithLabel.defaultProps = {
  isPasswordInput: false
}

const InputContainer = styled.div`
  width: 100%;
  margin-top: 5px;
`

const MyLabel = styled.div`
  display: inline;
  padding: 0 10px;
  height: 10px;
  position: relative;
  top: 10px;
  left: 10px;
  z-index: 10;
  background: white;
  font-size: 13px;
  color: gray;
`

const MyInput = styled(Input)`
  outline: 0;
  -webkit-box-shadow: 0 0 0 1px #cccccc;
  border: none;
  height: 2.5rem;
  font-size: 15px;

  :focus {
    -webkit-box-shadow: 0 0 0 1px #007AFF;
  }
`

const MyPasswordInput = styled(Input.Password)`
  outline: 0;
  -webkit-box-shadow: 0 0 0 1px #cccccc;
  border: none;
  height: 2.5rem;
  font-size: 15px;

  :focus {
    -webkit-box-shadow: 0 0 0 1px #007AFF;
  }
  
`


export default InputWithLabel
